import { Stack, Typography } from "@mui/material";
import { useCallback } from "react";
import toast from "react-hot-toast";

import { useReadProjectComment } from "../../../../hooks/react-query/project/use-project-comment";
import { TProject } from "../../../../models";
import { createAnnotationProject } from "../../../../services/projects";
import { TUseFetch } from "../../../../types/TUseFetch";
import AnnotationCard from "./annotation-card";
import AnnotationForm from "./annotation-form";

type TAnnotationTabProps = {
    project: TProject;
    getProject: TUseFetch;
};

function AnnotationTab({ getProject, project }: TAnnotationTabProps) {
    const { data, refetch } = useReadProjectComment({
        projectId: project.id_e,
    });
    const handleCreateAnnotation = useCallback(
        async (comment: string) => {
            await createAnnotationProject({
                projectId: project.id_e,
                params: { text: comment },
            });

            await refetch();
            toast.success("Anotação criada com sucesso!");
        },
        [getProject]
    );

    const annotationsData = data?.data ?? [];

    return (
        <Stack>
            <Stack
                sx={{
                    justifyContent: "center",
                    gap: "0.5rem",
                    p: "1.5rem",
                    borderBottom: "1px solid rgba(224, 224, 224, 1)",
                    borderTop: "1px solid rgba(224, 224, 224, 1)",
                }}
            >
                <Typography variant="h5">Anotações</Typography>
                <Typography
                    variant="subtitle2"
                    sx={{
                        color: "rgba(62, 55, 78, 0.60)",
                        fontFamily: "Noto Sans",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "18px",
                        letterSpacing: "0.07px",
                    }}
                >
                    Escreva insights do orçamento e projeto aqui.
                </Typography>
            </Stack>
            <Stack
                sx={{
                    p: "1.5rem",
                    gap: "1.5rem",
                }}
            >
                <Typography variant="h5">Anotações</Typography>
                <AnnotationForm
                    handleCreateAnnotation={handleCreateAnnotation}
                />
                <Stack
                    sx={{
                        gap: "1.5rem",
                        maxHeight: "28.5rem",
                        pt: "1rem",
                        overflowY: "auto",
                    }}
                >
                    {annotationsData
                        .map((annotation) => (
                            <AnnotationCard
                                key={annotation.id_e}
                                annotationData={annotation}
                                refetch={refetch}
                                project={project}
                            />
                        ))
                        .reverse()}
                </Stack>
            </Stack>
        </Stack>
    );
}

export default AnnotationTab;
